import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import EchartsReact from 'echarts-for-react';
import mapEn from './mapEn.json';

// 过滤华南区域中低纬度的南海诸岛线段，让ECharts注册的数据源本身不再绘制下方五段线
const chinaMapWithoutSouthSeaLines = {
    ...mapEn,
    features: mapEn.features.map(feature => {
        if (feature.properties?.name !== 'South' || feature.geometry?.type !== 'MultiPolygon') {
            return feature;
        }

        return {
            ...feature,
            geometry: {
                ...feature.geometry,
                coordinates: feature.geometry.coordinates.filter(polygon => {
                    const points = polygon.flat();
                    const maxLatitude = Math.max(...points.map(point => point[1]));
                    return maxLatitude >= 18;
                })
            }
        };
    })
};

const EchartsComponent = ({ selectedRegions, setSelectedRegions }) => {
    const selectedRegionStyle = {
        color: '#0c697c',
        areaColor: '#167f91',
        borderColor: '#0c697c',
        shadowColor: 'rgba(8, 89, 105, 0.18)',
        shadowBlur: 6,
    };
    const unselectedRegionStyle = {
        color: '#ffffff',
        areaColor: '#ffffff',
        borderColor: 'rgba(25, 119, 141, 0.32)',
    };
    const initialModes = [
        // 与新版type=1文件中的region编码保持一致
        { name: 'Northeast', value: "NE", key: 'NE' },
        { name: 'East', value: "EC", key: 'EC' },
        { name: 'North', value: "NC", key: 'NC' },
        { name: 'Central', value: "CC", key: 'CC' },
        { name: 'South', value: "SC", key: 'SC' },
        { name: 'Northwest', value: "NW", key: 'NW' },
        { name: 'Southwest', value: "SW", key: 'SW' },
    ];

    const [selectedMode, setSelectedMode] = useState(
        initialModes.map(mode => ({
            ...mode,
            itemStyle: mode.itemStyle || {
                ...selectedRegionStyle
            },
            label: mode.label || {
                fontSize: 12,
                color: "#fff",
            },
            ...(mode.name !== "南海诸岛" && { choosed: true })
        }))
    );

    useEffect(() => {
        // 更新EchartsComponent的选中状态
        const updatedSelectedMode = initialModes.map(region => ({
            ...region,
            itemStyle: selectedRegions.includes(region.value)
                    ? selectedRegionStyle
                    : unselectedRegionStyle,
            label: {
                    fontSize: 12,
                    color: selectedRegions.includes(region.value) ? "#fff" : "#315a68",
                },
            choosed: selectedRegions.includes(region.value),
        }));

        setSelectedMode(updatedSelectedMode);
    }, [selectedRegions]);


    const mainchart = useRef(null);

    echarts.registerMap("china-search-region", chinaMapWithoutSouthSeaLines);

    const option = {
        geo: {
            map: "china-search-region",
            silent: true,
            // 地图保持自然比例，避免在详情筛选区域中被横向或纵向拉伸
            layoutCenter: ['50%', '52%'],
            layoutSize: '108%',
            aspectScale: 0.75,
        },
        series: [
            {
                type: "map",
                map: "china-search-region",
                // 与 geo 使用同一比例配置，保证点击区域和视觉地图完全一致
                layoutCenter: ['50%', '52%'],
                layoutSize: '108%',
                aspectScale: 0.75,
                label: {
                    show: true
                },
                selectedMode: 'multiple', // 启用多选
                data: selectedMode,
            },
        ],
    };

    const toggleRegion = (data) => {
        const updatedSelectedRegions = selectedRegions.includes(data.value)
            ? selectedRegions.filter(region => region !== data.value)
            : [...selectedRegions, data.value];

        setSelectedRegions(updatedSelectedRegions);
    };

    return (
        <div className="region-map-chart">
            <EchartsReact
                ref={mainchart}
                option={option}
                onEvents={{
                    'click': (params) => {
                        const { data } = params;
                        toggleRegion(data);
                    }
                }}
                // 地图宽度跟随筛选卡片，避免在小屏和详情页中溢出
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default EchartsComponent;
